import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

const baseUrl = process.env.NEXT_PUBLIC_URL_BASE

interface BlogPostingProps {
  title: string
  image: string
  datePublished: string
  dateModified: string
  nameAuthor: string
  description: string
}

export const RichSnippetBlogPosting: React.FC<BlogPostingProps> = ({
  title,
  image,
  dateModified,
  datePublished,
  nameAuthor,
  description
}) => {
  const { asPath } = useRouter()
  const urlArticle = `${baseUrl}${asPath}`

  const richSnippet = {
    '@context': 'http://schema.org',
    '@type': 'BlogPosting',
    mainEntityOfPage: urlArticle,
    publisher: {
      '@type': 'Organization',
      name: 'Portal Solar - Tudo sobre Energia Solar Fotovoltaica',
      logo: {
        '@type': 'ImageObject',
        url: `${baseUrl}/assets/logo.png`,
        height: '48',
        width: '169'
      }
    },
    headline: title,
    author: [
      {
        '@type': 'Person',
        name: nameAuthor
      }
    ],
    datePublished: datePublished,
    dateModified: dateModified,
    image: {
      '@type': 'ImageObject',
      url: image,
      width: 895,
      height: 495
    },
    description: description
  }

  const data = JSON.stringify(richSnippet)

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: data }}
      ></script>
    </Head>
  )
}
